import { Component, h, Host, Prop } from '@stencil/core';

export interface ProductData {
  name: string;
  description?: string;
  price: number;
  productType?: string;
}

@Component({
  tag: 'order-overview-component',
  styleUrl: 'order-overview-component.scss',
  shadow: true,
})
export class OrderOverviewComponent {
  @Prop() productData: ProductData[];
  @Prop() sumText: string;
  @Prop() sum: number;
  @Prop() taxText: string;
  @Prop() taxRate: number = 0.19;

  private formatPrice(price: number): string {
    return Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price === 0 ? price : price / 100);
  }

  private getSum(): number {
    return this.productData.reduce((sum, order) => sum + order.price, 0);
  }

  private getTax(): number {
    return this.getSum() * this.taxRate;
  }

  render() {
    return (
      <Host>
        <div class="order-overview">
          {this.productData.map(orderItem => (
            <div class="order">
              <div class="item">{orderItem.name}</div>
              <div class="item">{this.formatPrice(orderItem.price)}</div>
              <div class="item">{orderItem.description}</div>
            </div>
          ))}
        </div>
        <div class="sum-overview">
          <div class="item">Gesamtsumme</div>
          <div class="item">{this.formatPrice(this.getSum())}</div>
          <div class="item">inkl. Mehrwertsteuer 19%</div>
          <div class="item">{this.formatPrice(this.getTax())}</div>
        </div>
      </Host>
    );
  }
}
